import { createSlice } from '@reduxjs/toolkit';

const initialExternalParamState = {
  tsysTransactionKey: '',
};

const externalSlice = createSlice({
  name: 'externalData',
  initialState: initialExternalParamState,
  reducers: {
    updateTsysTransactionKey(state, { payload }) {
      state.tsysTransactionKey = payload;
    },
  },
});

export const { updateTsysTransactionKey } = externalSlice.actions;
export default externalSlice.reducer;
